import React from "react";
import Grid from "@material-ui/core/Grid";
import StyledAppBar from "./AppBar.styled";
import Logo from "../../atoms/Logo";
import { ReactComponent as MenuIcon } from "../../../assets/icons/menu.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import ProfileIcon from "../../atoms/ProfileIcon";
import { IAppBar } from "./AppBar.interface";
import { H3 } from "../../atoms/H/H.styled";

const AppBar = ({ onMenuClick, ...props }: IAppBar) => {
  const { isMenuOpened } = props;
  const Icon = isMenuOpened ? CloseIcon : MenuIcon;

  return (
    <StyledAppBar {...props}>
      <Logo onClick={props.logoClickHandler} />
      {props.subtitle && <H3>{props.subtitle}</H3>}
      <Grid container justify="flex-end" alignItems="center" spacing={2}>
        <Grid item>{!props.isMenuOpened && props.profileElement}</Grid>
        <Grid item>
          <Icon onClick={onMenuClick} width={24} />
        </Grid>
      </Grid>
    </StyledAppBar>
  );
};

export default AppBar;
